import { Col, DatePicker, Form, Row } from "antd";
import React from "react";
import { defaultDateFormat } from "../constants/Helpers";
import BannerCard from "./BannerCard";

function QueryDateRange({ ...props }) {
  const style = { width: "100%" };

  // const dateRange = () => {
  //   const startDate = form.getFieldValue("startDate");
  //   const endDate = form.getFieldValue("endDate");
  //   if (endDate.diff(startDate, "days") > 14) {
  //     notification.error({ message: "Date range cannot exceed 14 days" });
  //     form.resetFields(["endDate"]);
  //   }
  // };

  return (
    <BannerCard title="Date Range">
      <Row gutter={8}>
        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
          <Form.Item label="Date" name="date">
            <DatePicker.RangePicker style={style} format={defaultDateFormat} />
          </Form.Item>
        </Col>
      </Row>
    </BannerCard>
  );
}

export default QueryDateRange;
